import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Unit, UnitCreate, UnitFilter } from '../data/unit';

export function createUnitService(client: AxiosInstance) {
  return createCrudService<Unit, UnitCreate, UnitFilter>(
    client,
    '/Unit',
    'unitId',
  );
}

export type UnitService = CrudService<Unit, UnitCreate, UnitFilter>;
